<div class="center">
    <div class="circle">
        <div class="checkmark"></div>
      </div>
    <br/>
    <p class="congrats">Congratulations!</p>
    <br/>
    <p>Carrier account with account reference/customer code - {{sageCustomerCode}} has been <span *ngIf="isAdmin">updated</span> <span *ngIf="!isAdmin">created</span> successfully.</p>
    <p>You can go to 'My Accounts' to create another account or you can apply for a permit.</p>

    <button class="btn btn-success" (click)="landing()">View accounts</button>
  </div>
